import { render, staticRenderFns } from "./LeaveCode.vue?vue&type=template&id=deae5060&scoped=true"
import script from "./LeaveCode.ts?vue&type=script&lang=ts&external"
export * from "./LeaveCode.ts?vue&type=script&lang=ts&external"
import style0 from "./LeaveCode.vue?vue&type=style&index=0&id=deae5060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deae5060",
  null
  
)

export default component.exports